import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import Cookies from 'js-cookie'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 120000 // 请求超时时间设置为1分钟
})

let lang = Cookies.get('language') || 'zh'

// request拦截器
service.interceptors.request.use(config => {
  //debugger
  // config.headers["Access-Control-Allow-Origin"] = "*";
  // config.headers["Access-Control-Allow-Credentials"] = "false";
  // config.headers["Access-Control-Allow-Methods"] = "GET, POST, PATCH, PUT, OPTIONS";
  // config.headers["Access-Control-Allow-Headers"] = "Content-Type, Accept, Authorization, X-Requested-With, Origin, Accept";

  //  config.header["Access-Control-Allow-Origin"] = "*";
  //  config.header["Access-Control-Allow-Headers"] = "X-Requested-With,Content-Type";
  //  config.header["Access-Control-Allow-Methods"] = "PUT,POST,GET,DELETE,OPTIONS";
  if (config.url.indexOf('token') < 0 && config.url.indexOf('WCFServices') < 0) {
    if (lang === 'zh') {
      lang = 'zh-CN'
    } else if (lang === 'en') {
      lang = 'en-US'
    }
    config.headers['voion-language'] = lang
  }
  if (store.getters.token) {
    if (config.url.indexOf('services/VoionERP') >= 0) {
      if (store.getters.userInfo.CompanyId) {
        config.headers['voion-companyid'] = store.getters.userInfo.ErpApiCompanyId
      }
    } else if (config.url.indexOf('token') < 0 && config.url.indexOf('WCFServices') < 0) {
      config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      if (store.getters.userInfo.CompanyId) {
        config.headers['voion-companyid'] = store.getters.userInfo.CompanyId
      }
    }
    else {
      console.log(config)
    }
    //https://q.cnblogs.com/q/73469/
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.config.url.indexOf('token') >= 0) {

      // if (response.data.LoginStatus !== 1) 
      // {
      //   return Promise.reject(response.data.ErrorMsg)
      // } 
      // else 
      // {
      //   return response.data
      // }

      if (response.status === 200) {
        return response.data
      }
      else {
        return Promise.reject('登录时(request.js文件未处理的状态码):' + response.status)
      }
    }
    else {
      return response.data
    }
  },
  error => {
    if (typeof (error.response) === "undefined") {
      error.message = "服务器无响应-500";
    }
    else {
      if (error.response.status === 400) {
        error.message = error.response.data.error_description;
      }
      else {

      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js